import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const FAQS = [
  {
    q: "¿Acepta seguros médicos?",
    a: "Sí. Trabajamos con las principales aseguradoras del país: GNP, AXA, MetLife, Mapfre, BUPA, Allianz y más. Te ayudamos con el trámite directo en consultorio para que solo te ocupes de tu salud.",
  },
  {
    q: "¿Hace visitas a domicilio?",
    a: "Sí. Contamos con servicio de consulta de cardiología a domicilio para pacientes con movilidad limitada o adultos mayores. Llevamos el equipo necesario para electrocardiograma y valoración completa.",
  },
  {
    q: "¿Qué precio tiene la consulta?",
    a: "Manejamos precios razonables y competitivos para Aguascalientes, con tarifas claras y sin sorpresas. Para conocer el costo exacto y paquetes de estudios diagnósticos, contáctanos por WhatsApp o teléfono.",
  },
  {
    q: "¿Puedo hacerme estudios el mismo día de la consulta?",
    a: "Sí. Eso es justamente lo que nos diferencia: ecocardiograma, electrocardiograma, prueba de esfuerzo, Holter y MAPA se realizan en el mismo consultorio, con interpretación inmediata del especialista.",
  },
  {
    q: "¿Cuánto dura la primera consulta?",
    a: "Aproximadamente 45–60 minutos. Tomamos el tiempo necesario para escucharte, revisar tu historial completo, hacer una exploración detallada y explicarte todo con claridad — incluyendo dibujos si hace falta.",
  },
  {
    q: "¿Atiende urgencias cardiológicas?",
    a: "Para urgencias cardíacas reales (dolor opresivo en el pecho, falta de aire súbita, palpitaciones intensas) acude inmediatamente a Urgencias del Hospital MAC Norte. Para consultas no urgentes, agenda por WhatsApp.",
  },
];

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="py-20 md:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <div className="text-center mb-12">
          <span className="text-[11px] uppercase tracking-[0.22em] text-[hsl(var(--soft-red))] font-medium">
            · Preguntas frecuentes ·
          </span>
          <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[hsl(var(--navy))] leading-[1.1]">
            Resolvemos tus
            <br />
            <span className="italic font-light">últimas dudas.</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-[hsl(var(--border))]"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-serif-display text-lg md:text-xl text-[hsl(var(--navy))] py-6 hover:no-underline text-left">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[hsl(var(--navy-soft))] text-base leading-relaxed pb-6 pr-8">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
